import { values } from 'lodash';
import uuid from 'uuid/v1';
import { FORM_MODES } from 'config/formModes';
import { TARGETING_TYPES } from 'modules/campaigns/modules/common-campaign-form';
import { generateCampaignEditorPath } from 'modules/campaigns/services/utils';
import { setRecommendations } from 'modules/recommendations';
import { CAMPAIGN_DIMENSION } from 'services/campaignDimension';
import { AUDIENCE_BUNDLES_INSIGHTS_REPORT_ID } from '../audience-bundles-insights/audienceBundlesInsightsReportId';
import { AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID } from '../audience-insights-demographics/audienceInsightsDemographicsReportId';
import { CONTEXTUAL_INSIGHTS_REPORT_ID } from '../contextual-insights/contextualInsightsReportId';
import { AUDIENCE_INSIGHTS_REPORT_ID } from './audineceInsightsReportId';

const reportTypeToSegmentData = include => ({
    [AUDIENCE_INSIGHTS_REPORT_ID]: {
        campaignTargeting: {
            marketplaceAudienceTargeting: {
                collection: [{ type: TARGETING_TYPES.INCLUDE, values: include, id: uuid() }],
                validTargeting: true,
            },
        },
    },
    [AUDIENCE_BUNDLES_INSIGHTS_REPORT_ID]: {
        campaignTargeting: {
            marketplaceAudienceTargeting: {
                collection: [{ type: TARGETING_TYPES.INCLUDE, values: include, id: uuid() }],
                validTargeting: true,
            },
        },
    },
    [AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID]: {
        campaignTargeting: {
            marketplaceAudienceTargeting: {
                collection: [{ type: TARGETING_TYPES.INCLUDE, values: include, id: uuid() }],
                validTargeting: true,
            },
        },
    },
    [CONTEXTUAL_INSIGHTS_REPORT_ID]: {
        campaignTargeting: {
            contextualSegmentsTargeting: { include },
        },
    },
});

export const generateBulkActionsOnDuplicateHandler =
    ({ selectedRows, selectedReport, selectedCampaign, navigate }) =>
    dispatch => {
        const selectedCampaignId = selectedCampaign?.id;
        const selectedCampaignOwner = selectedCampaign?.advertiserName;

        const selectedIds = values(selectedRows).map(({ id }) => id);

        const segmentsData = reportTypeToSegmentData(selectedIds)[selectedReport];

        const duplicateCampaignPath = generateCampaignEditorPath({
            mode: FORM_MODES.DUPLICATE,
            accountId: selectedCampaignOwner,
            campaignId: selectedCampaignId,
            dimension: CAMPAIGN_DIMENSION.SPONSORED,
        });

        const selectedSegmentsFromReport = {
            recommendationData: segmentsData,
        };

        dispatch(setRecommendations(selectedSegmentsFromReport));
        navigate(duplicateCampaignPath);
    };
